import React, { useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { marks } from '../../config/marks';
import "./Slider.css"

const useStyles = makeStyles({
  root: {
    marginLeft: 110,
    marginRight: 80,
    marginTop: 70,
    marginBottom:-10,
  }
});

const StyleSlider = withStyles({
  root: {
    color: '#48A6E0',
    height: 8,
  },
  markLabel: {
    color:'transparent',
  },
  mark: {
    width: '0px !important',
    },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: '#48A6E0',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    border: '2px solid currentColor',
    marginTop: -6,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-157%)',
    backgroundColor: '#48A6E0',

    width: 70,
    height: 42,

    fontSize: 22,
    textAlign: 'center',
    fontWeight: 600,
    lineHeight: '120%',

    marginTop: -16,
    paddingLeft: 11,
    paddingTop: 5,

    border: '2px solid #48A6E0',
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.08)',
    borderRadius: 8,
  },
  track: {
    height: 10,
    borderRadius: 4,
  },
  rail: {
    height: 10,
    backgroundColor:'white',
    borderRadius: 4,
    opacity: 1,
  },
})(Slider);


const valueLabelFormat = (value) => {
    let label = marks.find(mark => mark.value === value).label
    return label;
}

export default function MetsSlider({
    planType, 
    handleChange
}) {
  const classes = useStyles();

  const [state, setState] = useState({
    coordinate: 35,
    price: 900
  });

  const onChange = (name) => (e, value) => {
    let price;
    if (planType === 'Standard') {
      price =  marks.find(mark => mark.value === value).standardPrice;
    } else if (planType === 'Enterprise') {
      price = marks.find(mark => mark.value === value).enterprisePrice;
    } else if (planType === 'Mission Critical') {
      price = marks.find(mark => mark.value === value).mcPrice;
    }

    let yAxisCoordinate = marks.find(mark => mark.value === value).yAxisCoordinate;
    let mets = marks.find(mark => mark.value === value).key;

    setState({
      ...state,
      [name]: value,
      price: price
    });

    
    handleChange(price,mets,yAxisCoordinate);
  };

  return (
   <div className="react-slider-wrapper">
        <div className={classes.root}>
        <StyleSlider 
            valueLabelDisplay="on" 
            valueLabelFormat = {valueLabelFormat}
            name="coordinate"
            value={state.coordinate} //default value
            onChange={onChange('coordinate')}
            step={null}
            marks={marks}
        />
    </div>
   </div>
  );
}
